import {skipToken} from '@reduxjs/toolkit/query';
import assign from 'lodash/assign';

import {
  createFakeDocument,
  documents_list_fixture,
  getDocumentList,
} from 'app/demo/demo_fixtures/documents';
// @ts-expect-error this is a hidden module
import {eventEmitter} from 'app/procedures/api';

import {procedureDetailSource} from '../../demo_fixtures';
import {waitAndReturn} from '../../utils';

export const DOCUMENT_TAG = 'document';

export const useDocuments = (query: any, options: any) => {
  if (query == skipToken) {
    return {
      data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
        num_pages: 1,
      },
      refetch: () => {
        return null;
      },
    };
  }

  const documents = getDocumentList();
  const queryData = {
    data: {
      count: documents.length,
      next: null,
      previous: null,
      results: documents,
      num_pages: 1,
    },
    refetch: () => {
      return null;
    },
  };
  if (options != null && options.selectFromResult != null) {
    return options.selectFromResult(queryData);
  } else {
    return queryData;
  }
};

const updateConnections = () => {
  const connections = documents_list_fixture.map((doc) => ({
    folder: doc.folder,
    process: null,
    team: null,
    url: doc.url,
  }));
  assign(procedureDetailSource, {connections});
  eventEmitter.emit('procedureUpdate', {...procedureDetailSource});
};

const addToFolder = ({folder}) => ({
  unwrap: () => {
    return waitAndReturn(() => {
      const document = createFakeDocument(folder);
      if (document != null) {
        documents_list_fixture.push(document);
        updateConnections();
      }
      return document;
    });
  },
});

export const useAddToFolder = () => [addToFolder];

const removeFromFolder = ({id}) => ({
  unwrap: () => {
    const index = documents_list_fixture.findIndex(
      (document) => document.id === id
    );
    if (index >= 0) {
      documents_list_fixture.splice(index, 1);
      updateConnections();
    }
    return Promise.resolve(true);
  },
});

export const useRemoveFromFolder = () => [removeFromFolder];

export const useBulkRecycleDocuments = () => ({});
export const convertLocationParamsToFetchParams = () => ({});

export const convertLocationParamsFoldersDocumentsToFetchParams = () => ({});

const bulkAddToFolder = ({documents}) => ({
  unwrap: () => {
    return waitAndReturn(() => {
      documents.map((raw_document) => {
        const document = createFakeDocument(raw_document.folder);
        if (document != null) {
          documents_list_fixture.push(document);
          updateConnections();
        }
      });
    });
  },
});
export const useBulkAddToFolder = () => [bulkAddToFolder];
export const useBulkRemoveFromFolder = () => ({});
